/*eslint-disable multiline-ternary */
import { Card, Col, Form, Row } from 'react-bootstrap';
import './UploadDocument.scss';
import GenericButton from 'src/Components/GenericButton/GenericButton';
import {
  UploadFileIconSVG,
  DownloadAllFileIconSVG,
  IconSVG,
  IconDisabledSVG,
} from '../../img/uploadDocument/uploadDocumentSVG';
import DocumentDetailSkeleton from './skeleton/DocumentDetailSkeleton';
import useDocumentDetails from './hooks/useDocumentDetails';
import MasterPermissions from '../../api/MasterPermissions';
import { Link } from 'react-router-dom';

function DocumentDetail() {
  const {
    getdocumentDetail,
    loadingApiConfig,
    documentdetail,
    handleDownload,
    handleDownloadAll,
  } = useDocumentDetails();

  return (
    <div>
      <Card>
        <Form className="UploadFilesForm-Container">
          {loadingApiConfig ? (
            <DocumentDetailSkeleton />
          ) : (
            <>
              <Form.Group className="form-block mb-1" controlId="UploadFiles">
                <Row className="mt-4">
                  {/*<Col md={6} lg={6} sm={6}>
                    <Form.Group controlId="senddocumentfor">
                      <Form.Label className="document-labels">
                        Send Documents for
                      </Form.Label>
                      <Form.Control
                        readOnly
                        as="select"
                        name="senddocumentfor"
                        value={documentdetail?.senddocumentfor}
                        disabled
                      >
                        <option value={documentdetail?.senddocumentfor}>
                          {documentdetail?.senddocumentfor}
                        </option>
                      </Form.Control>
                    </Form.Group>
                  </Col> */}
                  <Col md={6} lg={6} sm={6}>
                    <Form.Group controlId="title">
                      <Form.Label className="document-labels">Title</Form.Label>
                      <Form.Control
                        readOnly
                        type="text"
                        name="title"
                        autoFocus={false}
                        value={
                          getdocumentDetail[0]?.Title || documentdetail?.Title
                        }
                      />
                    </Form.Group>
                  </Col>
                  <Col md={6} lg={6} sm={6}>
                    <Form.Group controlId="type">
                      <Form.Label className="document-labels">Type</Form.Label>
                      <Form.Control
                        readOnly
                        as="select"
                        name="type"
                        value={
                          getdocumentDetail[0]?.EntityType ||
                          documentdetail?.Type
                        }
                        disabled
                      >
                        <option
                          value={
                            getdocumentDetail[0]?.EntityType ||
                            documentdetail?.Type
                          }
                        >
                          {getdocumentDetail[0]?.EntityType ||
                            documentdetail?.Type}
                        </option>
                      </Form.Control>
                    </Form.Group>
                  </Col>
                </Row>

                {/*<Row className="mt-2">
                <Col md={6} lg={6} sm={6}>
                    <Form.Group controlId="referenceNumber">
                      <Form.Label className="document-labels">
                        Reference Number
                      </Form.Label>
                      <Form.Control
                        readOnly
                        type="text"
                        name="referenceNumber"
                        value={
                          getdocumentDetail[0]?.ReferenceNumber ||
                          documentdetail?.ReferenceNumber
                        }
                        autoFocus={false}
                      />
                    </Form.Group>
                </Col>
                </Row> */}
              </Form.Group>

              <div
                className={`file-information-class ${
                  getdocumentDetail?.length > 0 ? 'mt-4 mb-1' : 'mt-0'
                }`}
              >
                {getdocumentDetail &&
                  getdocumentDetail.map((fileinfo, index) => {
                    return (
                      <Row key={index} className="">
                        <Col md={6} lg={6} sm={6} className="">
                          <Card className="file-container">
                            <div className="img-icon-class">
                              <UploadFileIconSVG />
                              <div className="file-information">
                                <span className="file-name">
                                  {fileinfo.OrigFileName}
                                </span>
                                <br />
                                {MasterPermissions.CheckPermission(
                                  'Download Document',
                                ) ? (
                                  <span
                                    className="file-size"
                                    role="button"
                                    aria-label={`Click here to download ${fileinfo.OrigFileName} file`}
                                    onClick={handleDownload(fileinfo)}
                                  >
                                    <IconSVG />
                                    Download
                                  </span>
                                ) : (
                                  <span
                                    className="file-size-disable"
                                    role="button"
                                    aria-label={`Click here to download ${fileinfo.OrigFileName} file`}
                                  >
                                    <IconDisabledSVG />
                                    Download
                                  </span>
                                )}
                              </div>
                            </div>
                          </Card>
                        </Col>
                      </Row>
                    );
                  })}

                {getdocumentDetail && getdocumentDetail.length > 1 ? (
                  <Row className="mt-4">
                    <Col xs={8} sm={6} md={5} className="">
                      <div
                        className="sr-only"
                        aria-label="Download All button"
                        role="heading"
                      >
                        {' '}
                        Download All
                      </div>
                      <GenericButton
                        variant="primary"
                        tabIndex={0}
                        ariaLabel="Click here to download all the documents"
                        onClick={handleDownloadAll(
                          documentdetail?.Title,
                          getdocumentDetail[0].UploadedBatchOid,
                        )}
                        disable={
                          !MasterPermissions.CheckPermission(
                            'Download Document',
                          )
                        }
                        buttonDisabled={
                          !MasterPermissions.CheckPermission(
                            'Download Document',
                          )
                        }
                      >
                        <span className="">
                          <DownloadAllFileIconSVG />
                        </span>
                        Download All
                      </GenericButton>
                    </Col>
                  </Row>
                ) : (
                  ''
                )}
              </div>

              <Row className="mt-4 w-90">
                <Col md={12} lg={12} sm={12}>
                  <Form.Group className="form-block" controlId="comments">
                    <Form.Label className="document-labels">Comment</Form.Label>
                    <Form.Control
                      rows={4}
                      readOnly
                      as="textarea"
                      name="Comment"
                      autoFocus={false}
                      value={
                        getdocumentDetail[0]?.Comment || documentdetail?.Comment
                      }
                    />
                  </Form.Group>
                </Col>
              </Row>
              {/*<div className=" d-flex justify-content-between align-items-center mt-4 mb-4 button-container">
                <Link
                  to={'/member/messages-documents-notifications'}
                  state={{
                    documentDetailBackButton: true,
                    comingFrom: 'DashboardUploadIcon',
                  }}
                >
                  <button
                    className="cancel-btn border-0"
                    role="button"
                    aria-label="Click back button to go to documents list page"
                  >
                    Back
                  </button>
                </Link>
              </div> */}
            </>
          )}
        </Form>
      </Card>
    </div>
  );
}

export default DocumentDetail;
